import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { CloseIcon } from '../Icons/CloseIcon'

interface ConfirmModalProps<T> {
  title?: string
  Content: React.ComponentType<{ onChange: (data: T) => void }>
  onConfirm: (data: T | null) => void
  onCancel: () => void
  isMissionCASTExport: Boolean
  showControls: boolean
}

export function ConfirmModal<T>({
  title,
  Content,
  onConfirm,
  onCancel,
  isMissionCASTExport,
  showControls,
}: ConfirmModalProps<T>) {
  const [data, setData] = useState<T | null>(null)

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999999999]"
      onClick={onCancel}
    >
      <div
        className={` ${
          isMissionCASTExport ? 'absolute top-0 right-0' : 'relative'
        } bg-white p-6 rounded-lg shadow-md`}
        onClick={(e) => e.stopPropagation()}
      >
        {isMissionCASTExport && (
          <div className="absolute top-0 right-0">
            <button
              className="px-4 py-2 rounded mr-2 bg-white"
              onClick={onCancel}
            >
              <CloseIcon />
            </button>
          </div>
        )}
        {title && <h2 className="text-lg font-bold mb-4">{title}</h2>}
        <Content onChange={setData} />
        {showControls && (
          <div className="flex justify-end mt-4">
            <button
              className="px-4 py-2 bg-gray-300 rounded mr-2"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-green-500 text-white rounded disabled:bg-gray-500"
              onClick={() => onConfirm(data)}
              disabled={!(data && Object.keys(data).length)}
            >
              Confirm
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  )
}
